export default __webpack_public_path__ + "static/tannpuss-bc43f0310a6e74a2831bd79282ef9fb5.png";